export default "__VITE_ASSET__Ca9XQ9v1__"